import styled from 'styled-components';

const StyledWrapper = styled.div`
  margin-bottom: 56px;
  padding: 64px 0;
  & .icon_box {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto 20px;
    & .complete {
      display: block;
      width: 100%;
      height: 100%;
      background: url('/img/icon_complete.svg') no-repeat center / 96%;
    }
  }
  & h1 {
    margin-bottom: 12px;
    font-size: 32px;
    font-weight: 700;
    line-height; 1.3;
    color: #21212F;
    text-align: center;
  }
  & p {
    font-size: 20px;
    font-weight: 500;
    line-height; 1.4;
    color: #767676;
    text-align: center;
  }
`;

function ResultBox() {
  return (
    <StyledWrapper>
      <span className="icon_box">
        <i className="complete"></i>
      </span>
      <h1>문서 생성이 완료 되었습니다</h1>
      <p>다운로드 버튼을 클릭하여 완성된 파일을 받으세요</p>
    </StyledWrapper>
  );
}

export default ResultBox;
